import { useContext, useCallback, memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled, { ThemeContext } from 'styled-components';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import globalNavLogEvent from '../../utils/globalNavLogEvent.js';
import '../Link/index.js';
import './constants/index.js';
import GlobalNavContext from './context/GlobalNavContext.js';
import { jsx } from 'react/jsx-runtime';
import { COINBASE_LOGO_MAP } from './constants/constants.js';
import Link from '../Link/Link.js';
const LOGO_HEIGHT = 20;
const LOGO_WIDTH = 112;
const i18nKey = 'CoinbaseLogo';
const messages = defineMessages({
  homeLinkTitle: {
    id: `${i18nKey}.homeLinkTitle`,
    defaultMessage: 'Home',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Home link title (CharLimit autocalculated to 35)`
  },
  imgAltText: {
    id: `${i18nKey}.imgAltText`,
    defaultMessage: 'Coinbase Logo',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Alternative info for Coinbase Logo image (CharLimit autocalculated to 45)`
  }
});
const getLogoUrl = ({
  logoKey,
  useNewLogo
}) => {
  return COINBASE_LOGO_MAP[`${logoKey}${useNewLogo ? 'New' : ''}`];
};
function LogoWrapper({
  onMouseEnter,
  customLogoUrl
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const theme = useContext(ThemeContext);
  const _useContext = useContext(GlobalNavContext),
    useNewLogo = _useContext.useNewLogo,
    localeFromUrl = _useContext.localeFromUrl;
  const onLogoClick = useCallback(() => {
    globalNavLogEvent('global_nav_logo_click', {
      action: ActionType.click,
      componentType: ComponentType.link
    });
  }, []);
  const logoUrl = customLogoUrl || getLogoUrl({
    logoKey: theme?.logoKey || 'blue',
    useNewLogo
  });
  return /*#__PURE__*/jsx(Wrapper, {
    onMouseEnter: onMouseEnter,
    onClick: onLogoClick,
    children: /*#__PURE__*/jsx(StyledLink, {
      to: `https://www.coinbase.com${localeFromUrl ? `/${localeFromUrl}` : ''}`,
      title: formatMessage(messages.homeLinkTitle),
      testID: "header-home-link",
      children: /*#__PURE__*/jsx(Logo, {
        src: logoUrl,
        height: LOGO_HEIGHT,
        width: customLogoUrl ? '100%' : LOGO_WIDTH,
        alt: formatMessage(messages.imgAltText)
      })
    })
  });
}
const LogoWrapper$1 = /*#__PURE__*/memo(LogoWrapper);
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 3px;
  flex: 2;
`;
const StyledLink = styled(Link)`
  display: inline-flex;
  height: ${LOGO_HEIGHT}px;
`;
const Logo = styled.img`
  position: relative;
  max-height: ${LOGO_HEIGHT}px;
`;
export { LogoWrapper$1 as default };
//# sourceMappingURL=LogoWrapper.js.map
